import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class SubjectTeacherService {


  static getsubjectteacher(item) {


    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

    let api = `${API_BASE_URL}${dynamicPaths.getsubjectTeacher}`;

    const params = new URLSearchParams();

    if (item?.limit) params.append("limit", item.limit);
    if (item?.teacherId) params.append("teacherId", item.teacherId);
    if (item?.page) params.append("page", item.page);

    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }


    return axiosInstance.get(api);
  }

  static addsubjectteacher(data) {
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addsubjectteacher}`;
    return axiosInstance
      .post(api, data)

  }

  // static editclassteacher(data) {

  //     let api = '';
  //     api = `${API_BASE_URL}${API_PATHS.editclassTeacher}`;
  //     return axiosInstance
  //         .put(api,data)

  // }

  static deletesubjectteacher(id) {
    let api = '';

    api = `${API_BASE_URL}${API_PATHS.deletesubjectTeacher}?id=${id}`;

    return axiosInstance
      .delete(api)
  }


}

export default SubjectTeacherService;
